// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__RB4qa","rotation":"Spinner_rotation__Ecal6"};